module.exports = __webpack_public_path__ + "img/BTCP-alt.53e3521a.svg";